<template>
  <!-- 邀约参观详情 -->
  <div class="invitation-detail record-detail" v-loading="loading">
    <div class="invitation-info-tabs">
      <span class="tab-item" :class="{ active: activeTab === 'basic' }" @click="activeTab='basic'">信息采集</span>
      <span class="tab-item" :class="{ active: activeTab === 'invitation' }" @click="activeTab='invitation'">邀约参观</span>
      <span class="tab-item" :class="{ active: activeTab === 'leaderCoVisit' }" @click="activeTab='leaderCoVisit'">领导协访</span>
    </div>
    <div class="invitation-info-content">
      <!-- 基本信息 -->
      <div v-show="activeTab === 'basic'" class="info-block">
        <div class="block-content">
          <div class="sub-title">基本信息</div>
          <!-- 月收入 -->
          <div
            v-if="(showFormFieldKeyInfo.income_month_amount_formCode_FR007 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo.income_month_amount_formCode_FR007.zhName }}</span>
              <span class="row-value">{{ (formData.income_month_amount_formCode_FR007 || []).map(item => item.questionItemLabel).join('、') || '-' }}</span>
            </span>
          </div>
          <!-- 坐诊信息 -->
          <div class="sub-title">坐诊信息</div>
          <div v-for="(item, index) in seePatientList" :key="index" class="see-patient-info">
            <!-- 坐诊医院 -->
            <div
              v-if="(showFormFieldKeyInfo.hospital_formCode_FR008 || {}).isShow"
              class="info-row"
            >
              <span class="info-row-item">
                <span class="row-label">{{ showFormFieldKeyInfo.hospital_formCode_FR008.zhName + (index + 1) }}</span>
                <span class="row-value">{{ item.hospital_formCode_FR008 || '-' }}</span>
              </span>
            </div>
            <!-- 月度销售额 -->
            <div
              v-if="(showFormFieldKeyInfo.sales_month_amount_formCode_FR008 || {}).isShow"
              class="info-row"
            >
              <span class="info-row-item">
                <span class="row-label">{{ showFormFieldKeyInfo.sales_month_amount_formCode_FR008.zhName }}</span>
                <span class="row-value">
                  {{ item.sales_month_amount_formCode_FR008 || '-' }}{{ showFormFieldKeyInfo.sales_month_amount_formCode_FR008.unit || '' }}
                </span>
              </span>
            </div>
            <!-- 挂号费提成 -->
            <div
              v-if="(showFormFieldKeyInfo.register_commission_formCode_FR008 || {}).isShow"
              class="info-row"
            >
              <span class="info-row-item">
                <span class="row-label">{{ showFormFieldKeyInfo.register_commission_formCode_FR008.zhName }}</span>
                <span class="row-value">
                  {{ item.register_commission_formCode_FR008 || '-' }}{{ showFormFieldKeyInfo.register_commission_formCode_FR008.unit || '' }}
                </span>
              </span>
            </div>
            <!-- 药费提成 -->
            <div
              v-if="(showFormFieldKeyInfo.drug_commission_formCode_FR008 || {}).isShow"
              class="info-row"
            >
              <span class="info-row-item">
                <span class="row-label">{{ showFormFieldKeyInfo.drug_commission_formCode_FR008.zhName }}</span>
                <span class="row-value">
                  {{ item.drug_commission_formCode_FR008 || '-' }}{{ showFormFieldKeyInfo.drug_commission_formCode_FR008.unit || '' }}
                </span>
              </span>
            </div>
            <!-- 外治提成 -->
            <div
              v-if="(showFormFieldKeyInfo.physio_commission_formCode_FR008 || {}).isShow"
              class="info-row"
            >
              <span class="info-row-item">
                <span class="row-label">{{ showFormFieldKeyInfo.physio_commission_formCode_FR008.zhName }}</span>
                <span class="row-value">
                  {{ item.physio_commission_formCode_FR008 || '-' }}{{ showFormFieldKeyInfo.physio_commission_formCode_FR008.unit || '' }}
                </span>
              </span>
            </div>
          </div>
          <div v-if="seePatientList.length === 0" class="empty-block">-</div>
          <!-- 医生期望 -->
          <div class="sub-title">医生期望</div>
          <!-- 挂号费 -->
          <div
            v-if="(showFormFieldKeyInfo.register_price_formCode_FR010 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo.register_price_formCode_FR010.zhName }}</span>
              <span class="row-value">{{ formData.register_price_formCode_FR010 || '-' }}{{ showFormFieldKeyInfo.register_price_formCode_FR010.unit || '' }}</span>
            </span>
          </div>
          <!-- 挂号费提成 -->
          <div
            v-if="(showFormFieldKeyInfo.register_commission_formCode_FR010 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo.register_commission_formCode_FR010.zhName }}</span>
              <span class="row-value">
                {{ formData.register_commission_formCode_FR010 || '-' }}{{ showFormFieldKeyInfo.register_commission_formCode_FR010.unit || '' }}
              </span>
            </span>
          </div>
          <!-- 药费提成 -->
          <div
            v-if="(showFormFieldKeyInfo.drug_commission_formCode_FR010 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo.drug_commission_formCode_FR010.zhName }}</span>
              <span class="row-value">
                {{ formData.drug_commission_formCode_FR010 || '-' }}{{ showFormFieldKeyInfo.drug_commission_formCode_FR010.unit || '' }}
              </span>
            </span>
          </div>
          <!-- 外治提成 -->
          <div
            v-if="(showFormFieldKeyInfo.physio_commission_formCode_FR010 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo.physio_commission_formCode_FR010.zhName }}</span>
              <span class="row-value">
                {{ formData.physio_commission_formCode_FR010 || '-' }}{{ showFormFieldKeyInfo.physio_commission_formCode_FR010.unit || '' }}
              </span>
            </span>
          </div>
          <!-- 坐诊医馆 -->
          <div
            v-if="(showFormFieldKeyInfo.practice_hospital_formCode_FR010 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo.practice_hospital_formCode_FR010.zhName }}</span>
              <span class="row-value">
                {{ (formData.practice_hospital_formCode_FR010 || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </span>
            </span>
          </div>
          <!-- 坐诊时间 -->
          <div
            v-if="(showFormFieldKeyInfo.practice_time_formCode_FR010 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo.practice_time_formCode_FR010.zhName }}</span>
              <span class="row-value">
                {{ (formData.practice_time_formCode_FR010 || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </span>
            </span>
          </div>
        </div>
      </div>

      <!-- 邀约参观 -->
      <div v-show="activeTab === 'invitation'" class="info-block">
        <div class="block-content">
          <!-- 参观医馆 -->
          <div
            v-if="(showFormFieldKeyInfo.seevisit_hospital_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.seevisit_hospital_formCode_FR009.zhName }}</span>
              <div class="row-value">
                {{ (formData.seevisit_hospital_formCode_FR009 || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 参观时间 -->
          <div
            v-if="(showFormFieldKeyInfo.seevisit_time_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.seevisit_time_formCode_FR009.zhName }}</span>
              <div class="row-value">
                {{ formData.seevisit_time_formCode_FR009 || '-' }}
              </div>
            </span>
          </div>
          <!-- 参观照片 -->
          <div
            v-if="(showFormFieldKeyInfo.seevisit_picture_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.seevisit_picture_formCode_FR009.zhName }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData.seevisit_picture_formCode_FR009"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData.seevisit_picture_formCode_FR009"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData.seevisit_picture_formCode_FR009 || []).length === 0" class="empty">暂无参观照片</div>
              </div>
            </span>
          </div>
          <!-- 是否产生费用 -->
          <div
            v-if="(showFormFieldKeyInfo.is_fee_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.is_fee_formCode_FR009.zhName }}</span>
              <div class="row-value">
                {{ (formData.is_fee_formCode_FR009 || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 拜访费用 -->
          <div
            v-if="(showFormFieldKeyInfo.visit_fee_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.visit_fee_formCode_FR009.zhName }}</span>
              <div class="row-value">
                {{ formData.visit_fee_formCode_FR009 || '-' }}{{ showFormFieldKeyInfo.visit_fee_formCode_FR009.unit || '' }}
              </div>
            </span>
          </div>
          <!-- 费用明细 -->
          <div
            v-if="(showFormFieldKeyInfo.feed_detail_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.feed_detail_formCode_FR009.zhName }}</span>
              <div class="row-value">
                {{ formData.feed_detail_formCode_FR009 || '-' }}
              </div>
            </span>
          </div>
          <!-- 上传附件 -->
          <div
            v-if="(showFormFieldKeyInfo.attr_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.attr_formCode_FR009.zhName }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData.attr_formCode_FR009"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData.attr_formCode_FR009"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData.attr_formCode_FR009 || []).length === 0" class="empty">暂无附件</div>
              </div>
            </span>
          </div>
          <!-- 医生需求 -->
          <div
            v-if="(showFormFieldKeyInfo.feedback_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.feedback_formCode_FR009.zhName }}</span>
              <div class="row-value">
                {{ formData.feedback_formCode_FR009 || '-' }}
              </div>
            </span>
          </div>
          <!-- 陪同人 -->
          <div
            v-if="(showFormFieldKeyInfo.accompany_formCode_FR009 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.accompany_formCode_FR009.zhName }}</span>
              <div class="row-value">
                {{ formData.accompany_formCode_FR009 || '-' }}
              </div>
            </span>
          </div>
        </div>
      </div>

      <!-- 领导协访 -->
      <div v-show="activeTab === 'leaderCoVisit'" class="info-block">
        <div class="block-content">
          <!-- 协访时间 -->
          <div
            v-if="(showFormFieldKeyInfo.visit_time_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.visit_time_formCode_FR011.zhName }}</span>
              <div class="row-value">
                {{ formData.visit_time_formCode_FR011 || '-' }}
              </div>
            </span>
          </div>
          <!-- 协访领导 -->
          <div
            v-if="(showFormFieldKeyInfo.visit_leader_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.visit_leader_formCode_FR011.zhName }}</span>
              <div class="row-value">
                {{ (formData.visit_leader_formCode_FR011 || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 领导意见 -->
          <div
            v-if="(showFormFieldKeyInfo.visit_idea_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.visit_idea_formCode_FR011.zhName }}</span>
              <div class="row-value">
                {{ formData.visit_idea_formCode_FR011 || '-' }}
              </div>
            </span>
          </div>
          <!-- 协访照片 -->
          <div
            v-if="(showFormFieldKeyInfo.visit_picture_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.visit_picture_formCode_FR011.zhName }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData.visit_picture_formCode_FR011"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData.visit_picture_formCode_FR011"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData.visit_picture_formCode_FR011 || []).length === 0" class="empty">暂无协访照片</div>
              </div>
            </span>
          </div>
          <!-- 是否产生费用 -->
          <div
            v-if="(showFormFieldKeyInfo.is_fee_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.is_fee_formCode_FR011.zhName }}</span>
              <div class="row-value">
                {{ (formData.is_fee_formCode_FR011 || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 协访费用 -->
          <div
            v-if="(showFormFieldKeyInfo.visit_fee_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.visit_fee_formCode_FR011.zhName }}</span>
              <div class="row-value">
                {{ formData.visit_fee_formCode_FR011 || '-' }}{{ showFormFieldKeyInfo.visit_fee_formCode_FR011.unit || '' }}
              </div>
            </span>
          </div>
          <!-- 费用明细 -->
          <div
            v-if="(showFormFieldKeyInfo.feed_detail_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.feed_detail_formCode_FR011.zhName }}</span>
              <div class="row-value">
                {{ formData.feed_detail_formCode_FR011 || '-' }}
              </div>
            </span>
          </div>
          <!-- 上传附件 -->
          <div
            v-if="(showFormFieldKeyInfo.attr_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.attr_formCode_FR011.zhName }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData.attr_formCode_FR011"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData.attr_formCode_FR011"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData.attr_formCode_FR011 || []).length === 0" class="empty">暂无附件</div>
              </div>
            </span>
          </div>
          <!-- 医生需求 -->
          <!-- <div
            v-if="(showFormFieldKeyInfo.feedback_formCode_FR011 || {}).isShow"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo.feedback_formCode_FR011.zhName }}</span>
              <div class="row-value">
                {{ formData.feedback_formCode_FR011 || '-' }}
              </div>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const baseInfoFormCode = 'FR007'
const seePatientFormCode = 'FR008'
const invitationFormCode = 'FR009'
const doctorWishFormCode = 'FR010'
const leaderCoVisitFormCode = 'FR011'

export default {
  name: 'InvitationDetail',
  data() {
    return {
      loading: false,
      activeTab: 'basic',
      originOptionsInfo: {},
      showFormFieldKeyInfo: {},
      formData: {
        /* 基本信息 */
        income_month_amount_formCode_FR007: [], // 月收入

        /* 参观信息 */
        seevisit_id_formCode_FR009: '', // 参观ID
        seevisit_hospital_formCode_FR009: [], // 参观医馆
        seevisit_time_formCode_FR009: '', // 参观时间
        seevisit_timeTimeStamp: new Date().getTime(), // 参观时间时间戳
        fileIds: [], // 图片临时id列表
        seevisit_picture_formCode_FR009: [], // 图片地址列表
        is_fee_formCode_FR009: '', // 是否产生费用
        visit_fee_formCode_FR009: '', // 拜访费用
        feed_detail_formCode_FR009: '', // 拜访费用明细
        attrFileIds: [], // 上传附件图片id
        attr_formCode_FR009: [], // 上传附件
        feedback_formCode_FR009: '', // 医生需求
        accompany_formCode_FR009: '', // 陪同人

        /* 医生期望 */
        doctor_expectation_id_formCode_FR010: '', // 医生期望ID
        register_price_formCode_FR010: '', // 挂号费
        register_commission_formCode_FR010: '', // 挂号费提成
        drug_commission_formCode_FR010: '', // 药费提成
        physio_commission_formCode_FR010: '', // 外治提成
        practice_hospital_formCode_FR010: [], // 坐诊医馆
        practice_time_formCode_FR010: [], // 坐诊时间

      /* 协访 */
        help_visit_id_formCode_FR011: '', // 协访id
        visit_time_formCode_FR011: '', // 协访时间
        visitTimeTimeStamp: new Date().getTime(), // 协访时间时间戳（用于时间选择器）
        visit_leader_formCode_FR011: [], // 协访领导
        visit_result_formCode_FR011: [], // 协访结果
        visit_idea_formCode_FR011: '', // 领导意见
        fileIdsOfLeaderCoVisit: [], // 图片id
        visit_picture_formCode_FR011: [], // 图片地址列表
        is_fee_formCode_FR011: '', // 是产生协访费用
        visit_fee_formCode_FR011: '', // 协访费用
        feed_detail_formCode_FR011: '', // 协访费用明细
        attrFileIdsOfLeaderCoVisit: [], // 上传附件图片id
        attr_formCode_FR011: [], // 上传附件
        // feedback_formCode_FR011: '', // 医生需求
      },
      seePatientList: []
    }
  },
  methods: {
    async init(formCodeList) {
      this.loading = true
      try {
        await this.getFormFieldList(formCodeList)
        await this.getFormData(formCodeList)
      } catch (error) {
        console.error('获取表单字段配置信息失败', error)
      } finally {
        this.loading = false
      }
    },

    async getFormFieldList(formCodeList = []) {
      const {
        formData,
        showFormFieldKeyInfo,
        originOptionsInfo
      } = await formFlow.getFormFieldList(formCodeList)

      this.formData = formData
      this.showFormFieldKeyInfo = showFormFieldKeyInfo
      this.originOptionsInfo = originOptionsInfo
    },

    // 获取表单数据
    async getFormData(formCodeList = []) {
      const { formData, seePatientList } = this
      for (const formCode of formCodeList) {
        const data = await formFlow.getFormData({
          instanceId: this.currentRecordInfo.doctorStageId,
          stepCode: this.currentRecordInfo.stepCode,
          stepId: this.currentRecordInfo.stepId,
          formCode,
          doctorId: this.currentRecordInfo.doctorId,
          dataType: formCode === seePatientFormCode ? 'list' : 'obj',
          interfaceType: 'stepId'
        })
        // console.log('获取详情页面表单页面数据', data)
      
        // 表单获取的数据为空，则初始化表单id
        if (utils.getDataType(data) === 'object' && Object.keys(data.formData).length === 0) {
          continue
        }

        if (formCode === seePatientFormCode) {
          // 坐诊信息
          const resultSeePatientInfo = {
            doctor_practice_id_formCode_FR008: '', // 医生坐诊ID
            doctor_id_formCode_FR008: '', // 医生ID
            hospital_formCode_FR008: '', // 医院名称
            sales_month_amount_formCode_FR008: '', // 月度销售额
            register_commission_formCode_FR008: '', // 挂号费提成
            drug_commission_formCode_FR008: '', // 药费提成
            physio_commission_formCode_FR008: '' // 外治提成
          }
          for(const el of data) {
            const seePatientItem = {}
            for(const key in resultSeePatientInfo) {
              const item = el.formData[key] || {}
              const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
              if (utils.getDataType(resultSeePatientInfo[key]) === 'array') {
                // 单选/多选
                seePatientItem[key] = (this.originOptionsInfo[key] || []).filter(item => valueList.includes(item.questionItemValue))
              } else {
                seePatientItem[key] = valueList[0] || resultSeePatientInfo[key] || ''
              }
            }
            seePatientList.push(seePatientItem)
          }
        } else {
          for(const key in data.formData) {
            const item = data.formData[key] || {}
            const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
            if (
              [
              'seevisit_picture_formCode_FR009',
              'attr_formCode_FR009',
              'visit_picture_formCode_FR011',
              'attr_formCode_FR011',
              ].includes(key)
            ) {
              // 参观照片/上传附件/协访照片/上传附件
              const pictureList = valueList
              formData[key] = pictureList.map(item => this.imageBaseUrl + item)
            } else {
              if ([1, 2].includes(item.inputType)) {
                // 单选/多选
                formData[key] = (this.originOptionsInfo[key] || []).filter(item => valueList.includes(item.questionItemValue))
              } else {
                formData[key] = valueList[0] || formData[key] || ''
              }
            }
          }
        }
        this.formData = formData
        this.seePatientList = seePatientList
      }
    },
  },
  created() {
    const formCodeList = [baseInfoFormCode, seePatientFormCode, invitationFormCode, doctorWishFormCode, leaderCoVisitFormCode]
    this.init(formCodeList)
  },
  props: {
    currentRecordInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageBaseUrl() {
      return process.env.VUE_APP_ENV === 'production' ? 'https://image.scxinglin.com' : 'https://testdev.scxinglin.com'
      // return 'https://image.scxinglin.com'
    }
  }
}

</script>

<style scoped lang='less'>
@import '~@/views/DoctorVisitLTC/style/recordDetail.less';
.invitation-detail {
  .invitation-info-tabs {
    display: inline-flex;
    margin-bottom: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;

    .tab-item {
      padding: 6px 8px;
      border-right: 1px solid #e0e0e0;
      cursor: pointer;

      &:last-child {
        border-right: none;
      }

      &.active {
        background-color: #1890FF;
        color: #FFF;
      }
    }
  }

  .invitation-info-content {
    max-height: 500px;
    overflow-y: auto;
  }

  .sub-title {
    font-size: 14px;
    font-weight: 600;
    color: #1F2329;
    margin-bottom: 10px;
  }

  .block-content {
    padding: 0 6px;
  }

  .see-patient-info {
    display: inline-flex;
    flex-direction: column;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 6px 10px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-right: 10px;
    width: calc(50% - 15px);

    &:nth-child(3n + 1) {
      margin-right: 0;
    }

    .info-row:last-child {
      margin-bottom: 0;
    }
  }

  .empty-block {
    margin: 4px 0 16px;
    color: #1F2329;
    font-size: 13px;
  }

  .row-label {
    width: 100px !important;
  }
}
</style>